import { useEffect, useRef, useState } from 'react';
import { Input as FormikInput } from 'components/partials/Fields/FormikInput';
import FormikAddressSelect from 'components/partials/Fields/FormikAddressSelect';
import FormikStateSelect from 'components/partials/Fields/FormikStateSelect';
import FormikTimezones from 'components/partials/Fields/FormikTimezones';
import FormikZipcode from 'components/partials/Fields/FormikZipcode';
import DoubleColumn from 'components/FormikForm/Section/DoubleColumn';
import { CountrySelect } from 'components/partials/Fields/FormikCountrySelect';
import { useFormikContext } from 'formik';
import Col from 'react-bootstrap/Col';

const Address = ({
    formik = false,
    addCountry = false,
    isAuctionBuyer = false,
    settingsPage = false,
    disableTimezones = false,
}) => {
    const [loadingTimezones, setLoadingTimezones] = useState(false);
    const { initialValues, values, setFieldValue } = useFormikContext();
    const initialCountry = initialValues?.country_id;
    const isFirstRun = useRef(true);

    const handleKeyDown = (event) => {
        if (event.key == 'Enter' || event.keyCode == 13) {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    useEffect(() => {
        if (formik) {
            if (values?.country_id !== initialCountry) {
                setFieldValue('timezone_id', '');
                setFieldValue('state_id', '');
                setFieldValue('zipcode', '');
                setFieldValue('city', '');
                setFieldValue('address', '');
            }
        }
    }, [values?.country_id]);

    useEffect(() => {
        if (formik) {
            if (isFirstRun.current) {
                if (values?.address === '' || values?.address === undefined) {
                    const timer = setTimeout(() => {
                        setFieldValue('state_id', '');
                        setFieldValue('zipcode', '');
                        setFieldValue('city', '');
                        setFieldValue('timezone_id', '');
                    }, 3000);

                    return () => clearTimeout(timer);
                }
                isFirstRun.current = false;
            } else {
                if (values?.address === '' || values?.address === undefined) {
                    setFieldValue('state_id', '');
                    setFieldValue('zipcode', '');
                    setFieldValue('city', '');
                    setFieldValue('timezone_id', '');
                }
            }
        }
    }, [values?.address]);

    const disableAddressSelect = settingsPage && isAuctionBuyer;

    return <>
        {addCountry && (
            <CountrySelect stateField="state_id"/>
        )}
        <Col style={{ marginBottom: '25px', padding: 0 }}>
            <FormikAddressSelect
                onKeyDown={handleKeyDown}
                formik
                initialSearch={values?.address || ''}
                name="address"
                disabled={!values?.country_id || disableAddressSelect}
                setFieldValue={setFieldValue}
                countryField="country_id"
                setLoadingTimezones={setLoadingTimezones}
            />
        </Col>
        <DoubleColumn>
            <FormikInput
                name="city"
                label="City"
                disabled
                value={values?.city}
                formik
            />
            <FormikStateSelect disabled/>
            <FormikZipcode disabled/>
            <FormikTimezones name="timezone_id" disabled={disableTimezones} loading={loadingTimezones}/>
        </DoubleColumn>
    </>;
};

export default Address;
